import dynamic from 'next/dynamic';

const Content = dynamic(() => import('./content'));

export default Content;
